// Values baked in at build time by esbuild `define` (see scripts/build-config.mjs).
// The typeof guards keep the modules usable unbundled, for example in unit tests.

/* global __VERSION__, __ASSET_PATH__ */

/** Version of this build, from package.json. */
export const VERSION = typeof __VERSION__ === 'string' ? __VERSION__ : '0.0.0-dev';

/**
 * Where replay.js and recorder.js live, relative to loader.js.
 * Production builds use `../<version>/` so that a loader served from an alias
 * folder (for example /v0/) always loads the files from its own exact version.
 */
export const ASSET_PATH = typeof __ASSET_PATH__ === 'string' ? __ASSET_PATH__ : './';

/** Attribute on our Shadow DOM host. rrweb, screenshots and click capture all skip it. */
export const HOST_ATTRIBUTE = 'data-adido-bugs';

/** Schema version of the report payload. Bump when the shape changes incompatibly. */
export const PAYLOAD_VERSION = 1;

export const STORAGE_PREFIX = 'adido-bugs:';
